import { useNavigate } from "react-router-dom";
import { Theme } from "../../data/style/Theme";
import { likeWorkout } from "../../api/workouts";
import * as routes from "../../data/links/routes";
import { errorTexts } from "../../data/assets/texts";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { AllCenteredColumn, MainText } from "../../data/style/Style";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useNotifications } from "../../context/NotificationContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const Like = (props) => {
  let { count, wod_id, isLiked } = props;
  const { enableNotification } = useNotifications();
  const client = useQueryClient();
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: likeWorkout,
    onSuccess: (response) => {
      client.invalidateQueries({ queryKey: ["workout", wod_id] });
    },
    onError: (error) => {
      if (error.response.status === 400) {
        enableNotification(error.response.data.message, "error");
        return;
      }

      if (error.response.status === 403) {
        navigate(routes.LOGIN);
        return;
      }

      if (error.response.status >= 500) {
        enableNotification(errorTexts.system_error, "error");
      }
    },
  });

  let handleLikeWorkout = () => mutate({ wod_id });

  return (
    <AllCenteredColumn
      sx={{
        cursor: "pointer",
        height: "100%",
        width: "25%",
      }}
      gap={1}
    >
      {isLiked ? (
        <FavoriteIcon
          onClick={handleLikeWorkout}
          sx={{ color: Theme.palette.down }}
        />
      ) : (
        <FavoriteBorderIcon
          onClick={handleLikeWorkout}
          sx={{ color: "#fff" }}
        />
      )}
      <MainText sx={{ color: Theme.palette.muted + " !important" }}>
        {count}
      </MainText>
    </AllCenteredColumn>
  );
};

export default Like;
